/**
 * 회의록 탭의 「진행 중」 목록 나누기 (v2.229.2).
 *
 * 서버(/expense/docs?group=meeting&notFinal=1)는 열람 범위 안의 진행 중 회의록을 **전부** 준다 —
 *   부서장·경영지원·대표이사·관리자에게는 남의 것까지. 화면은 그것을 둘로 나눈다.
 *   · mine         = 내가 쓴 것 + 내가 참석자로 올라 있는 것 (모든 사람)
 *   · othersForCeo = 그 밖의 진행 중 회의록 — **대표이사에게만** 보여 준다
 *     (사용자 10-06 「회의록 작성된 내용은 참가자가 아니더라도 대표이사(이승환)은 볼 수 있도록」).
 *     전에는 mine 만 남겨, 대표이사는 참석하지 않은 회의록을 서명이 다 끝나기 전까지 못 봤다.
 * 백엔드 그물 verify:meeting 이 이 파일을 직접 불러 실제 서버 응답으로 시험한다.
 */
export interface OpenMeetingRow {
  authorId: string;
  iAmAttendee: boolean;
}

export function splitOpenMeetings<R extends OpenMeetingRow>(
  rows: R[],
  me: string | undefined,
  viewerIsCeo: boolean | undefined,
): { mine: R[]; othersForCeo: R[] } {
  const mine: R[] = [];
  const others: R[] = [];
  for (const r of rows) {
    if (r.authorId === me || r.iAmAttendee) mine.push(r);
    else others.push(r);
  }
  return { mine, othersForCeo: viewerIsCeo ? others : [] };
}
